/* eslint-disable @typescript-eslint/indent */
import { createApi } from '@reduxjs/toolkit/query/react';
import { TServerResponse } from 'app/types/server-response';
import { logisticsAPIBase } from 'app/utilities/env';
import getBaseQueryWithLogout from 'app/utilities/getBaseQuery';

import { TOrder } from '../types/order';

export const ordersApiSlice = createApi({
  reducerPath: 'ordersApi',
  baseQuery: getBaseQueryWithLogout(logisticsAPIBase),
  tagTypes: ['Orders'],
  endpoints: (build) => ({
    getUserOrders: build.query<TOrder[], number>({
      query: (id) => `/users/${id}/orders`,
      transformResponse: (res: TServerResponse<TOrder[]>) => res.data,
      providesTags: ['Orders'],
    }),
  }),
});

export const { useGetUserOrdersQuery, useLazyGetUserOrdersQuery } =
  ordersApiSlice;
